//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomRadio from './radio'
export default {
    components: {
        CustomRadio
    },
    props: {
        is_couple: Boolean,
        age: Number,
        gender: String
    },
    methods: {
        change (key, e) {
            console.error(key, e)
            this.$emit(`update:${key}`, e.target.value)
        },
        changeAge (e) {
            this.$emit(`update:age`, Number(e.target.value))
        }
    }
}
